import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { PlannedTwinID } from '@ynomia/core/dist/blueprint';
import { ActionFromPayloadMap } from '../config/types';
import PlanReducer from '../reducers/plans';

export type PlanStateType = {
  plannedTwinIDsKeyedById: Map<string, PlannedTwinID>
  isFetchingPlans: boolean
};

export type PlanActionPayloadMap = {
  SET_PLANNED_TWIN_IDS: Map<string, PlannedTwinID>;
  SET_FETCHING_PLANNED_TWIN_IDS: boolean;
};

export type PlanAction = ActionFromPayloadMap<PlanActionPayloadMap>;

const initialState: PlanStateType = {
  plannedTwinIDsKeyedById: new Map(),
  isFetchingPlans: false,
};

export const PlanContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<PlanAction>,
});

export const usePlan = (): [PlanStateType, React.Dispatch<PlanAction>] => {
  const { state, dispatch } = useContext(PlanContext);
  return [state, dispatch];
};

export const PlanProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(PlanReducer, initialState);

  return (
    <PlanContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
};
